// extracted by css-extract-rspack-plugin
export default {"cls1":"LoswpTabsHero-cls1_6Rk","cls2":"LoswpTabsHero-cls2_IuE LoswpTabsHero-cls1_6Rk"};